import { combineReducers } from "redux";
// Front
import Layout from "./layout/reducer";

// Authentication
import Login from "./auth/login/reducer";
import Account from "./auth/register/reducer";
import ForgetPassword from "./auth/forgetpwd/reducer";

//Company
import Company from "./company/reducer";

//User
import User from "./users/reducer";

//System User
import SystemUser from "./systemusers/reducer";

// Profile
import Profile from "./profiles/reducer";

// Group
import Group from "./groups/reducer";

// Department
import Department from "./departments/reducer";

// Skill
import Skill from "./skills/reducer";

// Role
import Role from "./roles/reducer";

// Edit Profile
import EditProfile from "./editprofile/reducer";

//Insights
import Insights from "./insights/reducer";

//Client Systems Variables
import ClientSystems from "./clientsystemsvariables/reducer";

//System Variables
import ClientSystemVariables from "./systemvariables/reducer";

const rootReducer = combineReducers({
  // public
  Layout,
  Login,
  Account,
  ForgetPassword,
  Company,
  User,
  SystemUser,
  Profile,
  Group,
  Department,
  Skill,
  Role,
  EditProfile,
  Insights,
  ClientSystems,
  ClientSystemVariables,
});

export default rootReducer;
